import _, { each } from 'lodash';
import dayjs from 'dayjs';
import { Timezones } from '@/@core/utils/timezone';
import { precision } from './number';
export const dateFormatString = 'YYYY-MM-DD';
export const enDateFormatString = 'MMM DD, YYYY';
export const dateFormatYMDHMS = 'YYYY-MM-DD HH:mm:ss';
export const enDateFormatYMDHMS = 'MMM DD, YYYY HH:mm:ss';
export function getTimezoneId() {
    if (window.Intl) {
        const result = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // IE下不生效
        if (result) {
            return result;
        }
    }
    const offset = new Date().getTimezoneOffset();
    let id = '';
    for (let i = 0, len = Timezones.length; i < len; i++) {
        const item = Timezones[i];
        const [hour, min] = item.utc_offset.split(':');
        if (Number(hour) * 60 + Number(min) + offset === 0) {
            id = item.value;
            break;
        }
    }
    return id;
}
// in: 2019-09-03 12:00:00
// out: [2019-09-03, 12:00:00]
export function splitDateTime(datetime) {
    return datetime.split(' ');
}
export function getDate(datetime) {
    if (!datetime) {
        return datetime;
    }
    return splitDateTime(datetime)[0];
}
export function getTime(datetime) {
    if (!datetime) {
        return datetime;
    }
    return splitDateTime(datetime)[1];
}
export function formatDateRange(rng, link = '~') {
    const startDate = dayjs(new Date(rng.begin_at)).format(dateFormatString);
    const endDate = dayjs(new Date(rng.end_at)).format(dateFormatString);
    return `${startDate} ${link} ${endDate}`;
}
export function formDateFromTimeStamp(number) {
    const date = dayjs(new Date(number)).format(dateFormatString);
    return date;
}
// in: 2019-09-03 12:00:00
export function isExpireNow(time_str, format) {
    const expire = dayjs(time_str, format);
    return expire.isBefore(dayjs());
}
//
export function isExpireNowFromNumber(time) {
    const expire = dayjs(time);
    return expire.isBefore(dayjs());
}
export function isExpireToday(time) {
    const expire = dayjs(time);
    return expire.isBefore(dayjs(), 'day');
}
export function nowDateStr(format) {
    // format: 'YYYY-MM-DD'
    const now = dayjs();
    return now.format(format);
}
export function nowDateTimeStr(format) {
    // format: YYYY-MM-DD hh:mm:ss
    const now = dayjs();
    return now.format(format);
}
export function getDataFromString(dateTimeStr, format) {
    if (!dateTimeStr) {
        return null;
    }
    return dayjs(dateTimeStr, format).toDate();
}
export function extendsDateBegin(d) {
    if (d) {
        return `${d} 00:00:00`;
    }
    else {
        return '';
    }
}
export function extendsDateEnd(d) {
    if (d) {
        return `${d} 23:59:59`;
    }
    else {
        return '';
    }
}
export function timeNumber2Date(n, format = dateFormatString) {
    // format: YYYY-MM-DD
    return dayjs(n).format(format);
}
export function getDateFormatYMDHMS(n, locale) {
    const format = locale === 'en' ? enDateFormatYMDHMS : dateFormatYMDHMS;
    return dayjs(n).format(format);
}
export function getDateFormatYMD(n, locale) {
    const format = locale === 'en' ? enDateFormatString : dateFormatString;
    return dayjs(n).format(format);
}
export function getDateFormatYM(n) {
    return dayjs(n).format('YYYY-MM');
}
/** 全的时间戳，转化为 时分秒， 用来做对比 */
export function transformHMS(timeZone) {
    return dayjs(timeZone).format('HH:mm:ss');
}
export function getDateFormatYMDHSM(n) {
    if (!n) {
        return null;
    }
    return dayjs(n).format(`${dateFormatString}  hh:mm:ss`);
}
export function formatDateBegin(n, format = dateFormatString) {
    const dateStr = timeNumber2Date(n, format);
    return extendsDateBegin(dateStr);
}
export function formatDateEnd(n, format = dateFormatString) {
    const dateStr = timeNumber2Date(n, format);
    return extendsDateEnd(dateStr);
}
export function getMinMaxDuration(timeRanges, dateFormatMomentType = dateFormatString) {
    let max = -Infinity;
    let min = Infinity;
    each(timeRanges, timeRange => {
        min = timeRange.begin_at < min ? timeRange.begin_at : min;
        max = timeRange.end_at > max ? timeRange.end_at : max;
    });
    return {
        begin_at: min,
        begin_at_show: timeNumber2Date(min, dateFormatMomentType),
        end_at: max,
        end_at_show: timeNumber2Date(max, dateFormatMomentType),
    };
}
export function rangeMonth(start_date, end_date) {
    const startDate = dayjs(start_date, dateFormatString);
    const endDate = dayjs(end_date, dateFormatString);
    const res = [];
    while (startDate.isBefore(endDate)) {
        res.push(startDate.format(dateFormatString));
        startDate.add(1, 'months');
    }
    return res;
}
export function second2hour(s, decimals = 2) {
    const hour = s / 3600;
    return precision(hour, decimals);
}
export function addDays(start_date, days) {
    const startDate = new Date(start_date).getTime();
    return new Date(startDate + days * 24 * 60 * 60 * 1000);
}
export function unixEpoch2MS(n) {
    if (_.isNumber(n)) {
        return n;
    }
    else {
        return _.toNumber(n) * 1000;
    }
}
/**
 *
 * @param timeStr example '12:12'
 * @returns
 */
export function time2unixDiffMS(timeStr) {
    const [hours, minutes] = timeStr.split(':');
    const hoursN = _.toNumber(hours);
    const minutesN = _.toNumber(minutes);
    return (hoursN * 60 + minutesN) * 60 * 1000;
}
export function unixEpoch2Time(base, time) {
    const timeDiff = time - base;
    const totalMinutes = timeDiff / (60 * 1000);
    const minutes = totalMinutes % 60;
    const hours = _.floor(totalMinutes / 60);
    let minutesStr = `${minutes}`;
    if (minutes < 10) {
        minutesStr = `0${minutes}`;
    }
    return `${hours}:${minutesStr}`;
}
export function diffTimeRangeDays(start, end) {
    const days = dayjs(end).diff(dayjs(start), 'days');
    return days;
}
